module.exports = __webpack_public_path__ + "static/media/icon-action-call.bafed554.svg";